import styled from 'styled-components';

// Table Container
export const TableContainer = styled.div`
	max-height: 80vh;
	overflow-y: auto;
	overflow-x: auto;
	width: 100%;
	display: flex;
	justify-content: center;
	margin-top: 10px;
`;
// Table styling
export const Table = styled.table`
	width: 100%;
	border-collapse: collapse;
	font-size: 12px;
	text-align: center;

	th,
	td {
		padding: 8px;
		border-bottom: 1px solid #ddd;
		margin: auto;
	}

	th {
		background-color: #f2f2f2;
		position: sticky;
		top: 0;
		z-index: 1;
	}
`;

// Status with conditional styling

// Editable input field for email
export const EditInput = styled.input`
	padding: 8px;
	font-size: 11px;
	width: 100%;
	box-sizing: border-box;
`;

// Button for sending mail
export const SendButton = styled.button`
	padding: 10px;
	background-color: #4caf50;
	color: white;
	border: none;
	cursor: pointer;

	&:hover {
		background-color: #45a049;
	}
`;

export const CenteredStatusCell = styled.td`
	text-align: center; /* Center-aligns the content */
	vertical-align: middle; /* Center-aligns content vertically */
`;

//  Status
export const Status = styled.button`
	padding: 10px;
	background-color: transparent;
	color: ${props => (props.status === 'completed' ? 'green' : 'red')};
	border: 1px solid ${props => (props.status === 'completed' ? 'green' : 'red')};
	border-radius: 0;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px; /* Space between text and circle */
	margin: 0 auto; /* Centers the button inside the cell */

	&:hover {
		background-color: ${props =>
			props.status === 'completed' ? '#e0ffe0' : '#ffe0e0'};
	}
`;

// New Circle component
export const Circle = styled.span`
	width: 10px;
	height: 10px;
	background-color: ${props =>
		props.status === 'completed' ? 'green' : 'red'}; /* Red or green */
	border-radius: 50%; /* Makes it circular */
	display: inline-block;
`;

export const ChipContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	padding: 4px;
	background-color: #f7f7f7;
	border: 1px solid #ccc;
	border-radius: 4px;
`;

export const Chip = styled.div`
	display: flex;
	align-items: center;
	background-color: #e0e0e0;
	padding: 4px 8px;
	margin: 4px;
	border-radius: 16px;
`;

export const ChipText = styled.span`
	margin-right: 8px;
`;

export const RemoveChipButton = styled.button`
	background: none;
	border: none;
	color: #888;
	font-size: 16px;
	cursor: pointer;
	&:hover {
		color: #555;
	}
`;

export const ChipInput = styled.input`
	border: none;
	outline: none;
	flex-grow: 1;
	padding: 4px;
`;
